// extracted by mini-css-extract-plugin
module.exports = {"footer":"Card_footer__vLhGu","label":"Card_label__3vYbu","dashboardBtnWrapper":"Card_dashboardBtnWrapper__3Hg1f"};